module.exports = __webpack_public_path__ + "assets/9fe0f646e1df199e07ae7e1a7989814c.mp3";